export const optionsByFieldQuery = /* GraphQL */ `
  query OptionsByField(
    $fieldOptionsId: ID!
    $lang: ModelTranslationFilterInput
    $optionFilter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
    $childLimit: Int
  ) {
    optionsByField(
      fieldOptionsId: $fieldOptionsId
      filter: $optionFilter
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        label
        value
        userID
        organizationID
        status
        metadata {
          key
          value
          type
        }
        optionOptionsId
        fieldOptionsId
        updatedAt
        translations(filter: $lang, limit: 10) {
          items {
            id
            label
            lang
          }
        }
        options(filter: $optionFilter, limit: $childLimit) {
          items {
            id
            label
            value
            userID
            organizationID
            status
            metadata {
              key
              value
              type
            }
            optionOptionsId
            fieldOptionsId
            updatedAt
            translations(filter: $lang, limit: 10) {
              items {
                id
                label
                lang
              }
            }
          }
        }
      }
    }
  }
`

// Deleted records are witnesses only: never fetch their labels, translations,
// ownership or metadata through the consumer lookup.
export const optionDeletionWitnessesByFieldQuery = /* GraphQL */ `
  query OptionDeletionWitnessesByField(
    $fieldOptionsId: ID!
    $lang: ModelTranslationFilterInput
    $parentFilter: ModelOptionFilterInput
    $optionFilter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
    $childLimit: Int
  ) {
    optionsByField(
      fieldOptionsId: $fieldOptionsId
      filter: $parentFilter
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        status
        options(filter: $optionFilter, limit: $childLimit) {
          items {
            id
            label
            value
            userID
            organizationID
            status
            optionOptionsId
            fieldOptionsId
            updatedAt
            metadata {
              key
              value
              type
            }
            translations(filter: $lang, limit: 10) {
              items {
                id
                label
                lang
              }
            }
          }
        }
        deletedOptions: options(
          filter: { status: { eq: "DELETED" } }
          limit: $childLimit
        ) {
          nextToken
          items {
            id
            status
          }
        }
      }
    }
  }
`

export const optionDeletionWitnessChildrenQuery = /* GraphQL */ `
  query OptionDeletionWitnessChildren(
    $id: ID!
    $nextToken: String
    $limit: Int
  ) {
    getOption(id: $id) {
      options(
        filter: { status: { eq: "DELETED" } }
        limit: $limit
        nextToken: $nextToken
      ) {
        nextToken
        items {
          id
          status
        }
      }
    }
  }
`
